import React from 'react'
import TemplateBodyPreview from './templateBodyPreview';
import TemplateHeaderPreview from './templateHeaderPreview';
import TemplateFooterPreview from './templateFooterPreview';
import { createWhatsappTemplateHeaderVariable, WA_template_header_variable_data } from '../../../../../../../models/axiosModel';

interface templatePreviewGlobal {
    headerType: string,
    headerURL: string,
    headerVaraibleData: createWhatsappTemplateHeaderVariable[] | WA_template_header_variable_data[],
    isFooter: boolean | string,
    headerText: string,
    bodyText: string,
    footerText: string,
}

const TemplatePreviewGlobal = (props: templatePreviewGlobal) => {
    const { headerType, headerURL, headerVaraibleData, isFooter, headerText, bodyText, footerText } = props;

    return (
        <>
            <TemplateHeaderPreview
                headerType={headerType}
                url={headerURL}
                headerText={headerText}
                headerVaraibleData={headerVaraibleData}
            />

            <TemplateBodyPreview 
                bodyText={bodyText}
            />

            {isFooter && 
                <TemplateFooterPreview
                    footerText={footerText}
                />
            }
        </>
    )
}

export default TemplatePreviewGlobal
